import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { FoljaForma, FoljaMenyra, FoljaNumri, FoljaUrdheroreTrajtaTeShkurtraTeRasesKallezore, FoljaVeta } from '@core/enums/folja.enum';
import { FoljaUrdherore } from '@core/globals/folja/folja-urdherore-constants';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-kallezore-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaUrdheroreTrajtaTeShkurtraKallezoreFormulaService } from './folja-urdherore-trajta-te-shkurtra-kallezore-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaUrdheroreTrajtaTeShkurtraKallezoreService {
  constructor(private foljaUrdheroreTrajtaTeShkurtraKallezoreFormulaService: FoljaUrdheroreTrajtaTeShkurtraKallezoreFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezoreInitial', 'foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezore'];
    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateUrdheroreForms(formArray);
      foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezore?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('formaId')?.value == item.formaId &&
            c.get('numriId')?.value == item.numriId &&
            c.get('trajtaTeShkurtraKallezoreId')?.value == item.trajtaTeShkurtraKallezoreId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.formaId, item.numriId, item.trajtaTeShkurtraKallezoreId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateUrdheroreForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaUrdheroreTrajtaTeShkurtraKallezoreFormulaService.generateFormula(
      baza,
      foljaBaza,
      form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezore') as UntypedFormArray
    );
  }

  private generateUrdheroreForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const ff of FoljaConstants.FoljaForma) {
      for (const fttshk of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraKallezore) {
        for (const fn of FoljaUrdherore.FoljaNumri) {
          const foljaForm = this.fb.group({
            formaId: ff.id,
            numriId: fn.id,
            vetaId: FoljaVeta.Edyte,
            trajtaTeShkurtraKallezoreId: fttshk.id,
            pershkrimi: '',
            renditja: 1
          });

          formArray.push(foljaForm);
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, forma: FoljaForma, numri: FoljaNumri, ttshk: FoljaUrdheroreTrajtaTeShkurtraTeRasesKallezore, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.formaId == forma && c.numriId == numri && c.trajtaTeShkurtraKallezoreId == ttshk).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      formaId: forma,
      numriId: numri,
      vetaId: FoljaVeta.Edyte,
      trajtaTeShkurtraKallezoreId: ttshk,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaUrdheroreTrajtaTeShkurtraKallezoreForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraKallezore') as UntypedFormArray;

    const veproreParam = form.get('foljaBaza.veproreParam')?.value;
    const joveproreParam = form.get('foljaBaza.joveproreParam')?.value;

    let formArrayValue = formArray.getRawValue();

    if (!veproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.Veprore);
    }
    if (!joveproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.JoVeprore);
    }

    formArrayValue.forEach((e: any) => {
      creationDTO.push({
        numriId: e.numriId,
        formaId: e.formaId,
        vetaId: e.vetaId,
        trajtaTeShkurtraKallezoreId: e.trajtaTeShkurtraKallezoreId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: { menyraId: number; kohaId?: number; formaId?: number; vetaId?: number; numriId?: number; trajtaTeShkurtraKallezoreId: number, pershkrimi: string }[] = [];
    let initial = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraKallezoreInitial;
    let formula = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraKallezore;

    for (const ff of FoljaConstants.FoljaForma) {
      for (const fttshk of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraKallezore) {
        for (const fn of FoljaUrdherore.FoljaNumri) {

          const fmap = formula
            .filter((a: any) => a.formaId == ff.id && a.numriId == fn.id && a.trajtaTeShkurtraKallezoreId == fttshk.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          const imap = initial
            .filter((a: any) => a.formaId == ff.id && a.numriId == fn.id && a.trajtaTeShkurtraKallezoreId == fttshk.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          if (fmap != imap) {
            errors.push({
              menyraId: FoljaMenyra.Urdherore,
              formaId: ff.id,
              numriId: fn.id,
              trajtaTeShkurtraKallezoreId: fttshk.id,
              pershkrimi: imap
            });
          }
        }
      }
    }

    return errors;
  }
}
